module.exports = __webpack_public_path__ + "images/6b124b7064db0cf97a3c16202decb626c53cb3bb687c1817dd689affc09e61a8.svg";